export default "__VITE_ASSET__BUp4BxRd__"